import Page from "components/Page";
import Workspace from "components/Workspace";
import Tr from "translations/Translations";
import React, {useEffect, useMemo, useState} from "react";
import SearchBar from "./components/AuditAllowedObjectListSearchBar";
import Loading from "components/Loading";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import Pagination from "components/Pagination";
import useSearch from "hooks/useSearch";
import usePathParams from "hooks/usePathParams";
import {connect} from "react-redux";
import {withStyles} from "@material-ui/core";
import {withRouter} from "react-router";
import RouterPath, {createPath} from "../../../libs/RouterPath";
import WorkableIconPreviewButton from "../../../components/button/WorkableIconPreviewButton";
import AuditAllowedObjectService from "./service/AuditAllowedObjectService";

const style = theme => ({
    root: {
        padding: theme.spacing(2)
    },
    number: {
        width: 150
    },
    owner: {
        width: 250
    },
    button: {
        width: 50,
        padding: '0 !important',
    },
    gridNew: {
        padding: theme.spacing(0.5)
    },
    icon: {
        marginRight: theme.spacing(1)
    },
    buttonNew: {
        marginRight: theme.spacing(2)
    },
    cell: {
        padding: theme.spacing(1),
    }
})

function AuditAllowedObjectList ({
        auditAllowedObjectList = {},
        classes,
        adminMode = false
    }) {

    const { items } = auditAllowedObjectList;

    const [loading, setLoading] = useState(false);

    let params = usePathParams();
    const {searchData, totalCount, setTotalCount, setPaginationConfig, setSearchConfig, setSortConfig,}
        = useSearch({
        search: {
            params,
            filters: {}
        },
        sort: {
            column: 'objectNumber',
            direction: 'desc',
        }
    });

    const setFilters = (filters) => {
        const newFilters = {...searchData.search.filters, ...filters};
        setSearchConfig({...searchData.search, filters: newFilters});
    }

    useEffect(() => {
        return () => {
            AuditAllowedObjectService.clear();
        }
    }, []);

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line
    }, [searchData])

    const fetchData = () => {
        setLoading(true);
        const {search, pagination, sort} = searchData;
        const {page, pageSize} = pagination;
        AuditAllowedObjectService.get(page, pageSize, {
            ...search.filters,
            ...search.params,
        }, sort).then(x => {
            setTotalCount(x.totalCount);
            setLoading(false);
        });
    }

    const handleSortChange = (id) => {
        let direction = 'desc';
        const active = searchData.sort.column === id;
        if (active) {
            direction = searchData.sort.direction === 'asc' ? 'desc' : 'asc';
        }

        setSortConfig({
            column: id,
            direction
        })
    }

    const getSortProps = (id) => {
        return {
            active: searchData.sort.column === id,
            direction: searchData.sort.direction,
            onClick: () => {
                handleSortChange(id)
            }
        }
    }

    const getHeaders = () => {
        if (!items) return;
        const headers = [];
        headers.push({
            value: Tr('number_of_processing'),
            sort: getSortProps('objectNumber')
        });
        headers.push({
            value: Tr('name'),
            sort: getSortProps('objectName')
        });
        headers.push({
            value: Tr('owner')
        });
        headers.push('');
        return headers;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const headers = useMemo(getHeaders, [items]);

    const getHeaderClasses = () => {
        if (!items) return;
        const headers = [];
        headers.push(classes.number);
        headers.push(undefined);
        headers.push(classes.owner);
        headers.push(classes.button);
        return headers;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const headerClasses = useMemo(getHeaderClasses, [items]);

    const handleEnterObject = (item) => {
        if (!!item.api) {
            //w miare obslugi kolejnych modulu trzeba bedzie tu zmienic
            const path = createPath(RouterPath.myProcedure.steps.MP_1_ID, {id: item.objectIdentity});
            RouterPath.redirect(path);
        } else {
            window.location.href = item.url;
        }
    }

    const getRows = () => {
        if (!items) return;
        const rows = items.map((item) => {
            const row = [];
            row.push(item.objectNumber);
            row.push(item.objectName);
            row.push(item.objectOwner);
            row.push(<WorkableIconPreviewButton onClick={()=> handleEnterObject(item)} />);
            return row;
        });
        return rows;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const rows = useMemo(getRows, [items]);

    if (!items) return <Loading/>;

    return (
        <div className={classes.root}>
            <Page
                floatingWorkspace
            >
                <Workspace
                    title={Tr('audit_allowed_object_list')}
                >
                    <SearchBar
                        setFilters={setFilters}
                        filters={searchData.search.filters}
                        adminMode={adminMode}
                    />
                    {loading ?
                        <Loading/>
                        :
                        <SimpleTable
                            headers={headers}
                            items={rows}
                            columnClasses={headerClasses}
                            cellClassName={classes.cell}
                        />
                    }

                    <Pagination config={searchData.pagination} setConfig={setPaginationConfig} totalCount={totalCount}/>
                </Workspace>
            </Page>
        </div>
    )
}

export default connect((state) => ({
    auditAllowedObjectList: state.resources.auditAllowedObjectList
}), {})(withStyles(style)(withRouter(AuditAllowedObjectList)));